import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useScreen from 'hooks/useScreen';
import PDPSelectUpholsteryDecideLater from '../PDPSelectUpholstery/PDPSelectUpholsteryDecideLater';
const PDPDecideLaterOverlay = () => {
  const $ = _c(4);
  const {
    isMobile
  } = useScreen();
  let t0;
  if ($[0] !== isMobile) {
    t0 = isMobile ? <PDPSelectUpholsteryDecideLater /> : "Decide Later";
    $[0] = isMobile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="items-center bg-[hsla(0,0%,100%,.5)] flex h-full justify-center left-0 pointer-events-none absolute top-0 w-full z-[3]"><div className="text-sm font-bold bg-white rounded-sm text-gray px-6 py-3.5 lg:text-base lg:font-bold lg:px-4 lg:py-3.5 !bg-gray-light8/70">{t0}</div></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default PDPDecideLaterOverlay;